import * as React from "react"
const OutdoorIcon = (props) => (
    <img src="/Icons/outdoor.svg" alt="outdoor" {...props}/>
)
export default OutdoorIcon
